import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

// 异步actions
export const fetchVerificationCodes = createAsyncThunk(
  'verificationCode/fetchVerificationCodes',
  async (params, { rejectWithValue }) => {
    try {
      // 转换前端分页参数到后端分页参数
      const apiParams = {
        ...params,
        page: params.current || params.page || 1,
        limit: params.pageSize || params.limit || 20,
      };
      // 删除前端特有的字段
      delete apiParams.current;
      delete apiParams.pageSize;
      
      const response = await api.get('/admin/verification-codes', { params: apiParams });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || '获取验证码列表失败');
    }
  }
);

export const fetchVerificationCodeDetail = createAsyncThunk(
  'verificationCode/fetchVerificationCodeDetail',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`/admin/verification-codes/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || '获取验证码详情失败');
    }
  }
);

export const fetchVerificationCodeStatistics = createAsyncThunk(
  'verificationCode/fetchVerificationCodeStatistics',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get('/admin/verification-codes/statistics/summary', { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || '获取验证码统计失败');
    }
  }
);

// 初始状态
const initialState = {
  codes: [],
  codeDetail: null,
  statistics: null,
  pagination: {
    current: 1,
    pageSize: 20,
    total: 0,
  },
  filters: {},
  isLoading: false,
  error: null,
};

// slice
const verificationCodeSlice = createSlice({
  name: 'verificationCode',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    clearCodeDetail: (state) => {
      state.codeDetail = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // 获取验证码列表
      .addCase(fetchVerificationCodes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchVerificationCodes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.codes = action.payload.list || [];
        state.pagination = {
          current: action.payload.pagination?.page || 1,
          pageSize: action.payload.pagination?.limit || 20,
          total: action.payload.pagination?.total || 0,
        };
      })
      .addCase(fetchVerificationCodes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // 获取验证码详情
      .addCase(fetchVerificationCodeDetail.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchVerificationCodeDetail.fulfilled, (state, action) => {
        state.isLoading = false;
        state.codeDetail = action.payload;
      })
      .addCase(fetchVerificationCodeDetail.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // 获取验证码统计
      .addCase(fetchVerificationCodeStatistics.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchVerificationCodeStatistics.fulfilled, (state, action) => {
        state.isLoading = false;
        state.statistics = action.payload;
      })
      .addCase(fetchVerificationCodeStatistics.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, setFilters, setPagination, clearCodeDetail } = verificationCodeSlice.actions;
export default verificationCodeSlice.reducer;

